export default __webpack_public_path__ + "static/media/classicVsValley.fb0924c8.png";